"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSavePrice = exports.StyledSalePriceWrapper = exports.StyledPriceContainer = exports.StyledPrevPrice = exports.StyledBasicPrice = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var styledSalePriceWrapperConfig = _config.styledPriceConfig.styledSalePriceWrapperConfig;
var StyledPriceContainer = exports.StyledPriceContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-price'
}).withConfig({
  displayName: "styled-price__StyledPriceContainer",
  componentId: "sc-19t7mmi-0"
})([""]);
var getMarginByViewport = function getMarginByViewport(viewport) {
  var _styledSalePriceWrapp;
  return "\n\tmargin-bottom: ".concat((_styledSalePriceWrapp = styledSalePriceWrapperConfig.marginBottom) === null || _styledSalePriceWrapp === void 0 ? void 0 : _styledSalePriceWrapp[viewport], ";\n");
};
var setMarginBottom = function setMarginBottom(size) {
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  return isResponsive ? setViewportCss(getMarginByViewport) : getMarginByViewport(size);
};
var StyledSalePriceWrapper = exports.StyledSalePriceWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-price__sale-price-wrapper'
}).withConfig({
  displayName: "styled-price__StyledSalePriceWrapper",
  componentId: "sc-19t7mmi-1"
})(["", ""], function (_ref) {
  var size = _ref.size;
  return "\n\t\t".concat(setMarginBottom(size), "\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t");
});
var StyledBasicPrice = exports.StyledBasicPrice = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-price__basic-price',
  color: 'var(--color-global-black)'
}).withConfig({
  displayName: "styled-price__StyledBasicPrice",
  componentId: "sc-19t7mmi-2"
})(["color:", ";margin-right:var(--spacing-global-space2);"], function (_ref2) {
  var prevPrice = _ref2.prevPrice;
  return prevPrice ? "var(--color-universal-redMid)" : "var(--color-global-black)";
});
var StyledSavePrice = exports.StyledSavePrice = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-price__save-price',
  color: 'var(--color-universal-redMid)'
}).withConfig({
  displayName: "styled-price__StyledSavePrice",
  componentId: "sc-19t7mmi-3"
})(["margin-bottom:0px;"]);
var StyledPrevPrice = exports.StyledPrevPrice = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-price__prev-price',
  color: 'var(--color-global-black)'
}).withConfig({
  displayName: "styled-price__StyledPrevPrice",
  componentId: "sc-19t7mmi-4"
})(["text-decoration:line-through;margin-bottom:0;"]);